export var CONTENT_TABS = {
  WHY_WE_LIKE_IT: 'WHY_WE_LIKE_IT',
  PROS_CONS: 'PROS_CONS',
  PRODUCT_DETAILS: 'PRODUCT_DETAILS',
  KEY_FACTS: 'KEY_FACTS'
};
export var PREHEADER_TYPE = {
  PLAIN_TEXT: 'PLAIN_TEXT',
  DECORATED_TEXT: 'DECORATED_TEXT',
  BADGE: 'BADGE'
};
export var PREHEADER_TRK_LOCATION = {
  BEST_OF_BADGE: 'BestOfBadge',
  PREHEADER: 'Preheader'
};
export var SENTIMENT_TYPE = {
  GOOD: 'GOOD',
  NEUTRAL: 'NEUTRAL',
  BAD: 'BAD'
};
export var SENTIMENT_COLOR = {
  GOOD: 'green',
  NEUTRAL: 'neutral-darkest',
  BAD: 'red'
};
export var TRK_PRODUCT_LOCATION = 'MarketplaceProductCard';
export var COMPONENT_ANALYTICS_NAME = 'product_card';
export var MORE_DETAILS = "".concat(COMPONENT_ANALYTICS_NAME, "_more_details");